export default "5f48ea35d6c19672.svg"